import React, { useState, useEffect } from "react"
import { Radio } from "antd"
import { Link } from "react-router-dom"
import { Card, Button, Modal } from "react-bootstrap"
import GeneralRatesTour from "./GeneralRatesTour"
import axios from "axios"
import GeneralTransportationsTour from "./GeneralTransportationsTour"

const GeneralServicesTours = ({ product, tourId, tourProject }) => {
  const [hotelRates, setHotelRates] = useState([])
  const [tripPrice, setTripPrice] = useState(0)
  const [tripPriceBool, setTripPriceBool] = useState(false)
  const [numOfPassengers, setNumOfPassengers] = useState(0)
  const [kindOfTrip, setKindOfTrip] = useState("")
  const [chargeByPerson, setChargeByPerson] = useState(false)
  const [hotelName, sethotelName] = useState("")
  const [hotelId, sethotelId] = useState(0)
  const [zoneId, setzoneId] = useState(0)
  const [show, setShow] = useState(false)
  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)
  const [numOfPass, setNumOfPass] = useState([])
  const [transportationId, setTransportationId] = useState([])
  const [transportationNameSelected, setTransportationNameSelected] =
    useState("")
  const [transportationIdSelected, setTransportationIdSelected] = useState(0)
  const [isSelectedHotel, setIsSelectedHotel] = useState(false)
  const [showTransportations, setshowTransportations] = useState(false)
  const [render, setRender] = useState(false)

  const server = "https://transportation-backend.link"

  const getPricesAPI = (
    transportationIdSelected,
    numofpass,
    kindOfTrip,
    zoneId
  ) => {
    const fetchPrices = async () => {
      const { data } = await axios.get(
        `${server}/services/get-prices-tours-zones/${zoneId}/${transportationIdSelected}/${tourId}`
      )
      if (data.length) {
        let departureprice = data[0].departureprice
        let arrivalprice = data[0].arrivalprice
        let roundprice = data[0].roundprice
        setTripPriceBool(true)

        if (chargeByPerson) {
          if (kindOfTrip === "Departure") {
            setTripPrice(departureprice * numofpass)
          }
          if (kindOfTrip === "Arrival") {
            setTripPrice(arrivalprice * numofpass)
          }
          if (kindOfTrip === "Round") {
            setTripPrice(roundprice * numofpass)
          }
        } else {
          if (kindOfTrip === "Departure") {
            setTripPrice(departureprice)
          }
          if (kindOfTrip === "Arrival") {
            setTripPrice(arrivalprice)
          }
          if (kindOfTrip === "Round") {
            setTripPrice(roundprice)
          }
        }
      } else {
        setTripPrice(0)
        setTripPriceBool(false)
      }
    }

    if (zoneId !== " " && transportationIdSelected !== " ") {
      fetchPrices()
    } else {
      setTripPrice(0)
      setTripPriceBool(false)
    }
  }

  const fetchHotelRates = async (tourId) => {
    const { data } = await axios.get(`${server}/hotels-tours/${tourId}`)

    data.unshift({
      id: 0,
      Name: " ",
    })

    setHotelRates(data)
  }

  const fetchNumOfPass = async () => {
    const { data } = await axios.get(
      `${server}/services/num-of-pass-tours/${product._id}/${tourId}`
    )

    let numPass = []
    let transpId = []

    for (let i in data) {
      numPass.push(data[i].NumOfPass)
      transpId.push(data[i].GeneralTransportationId)
    }
    transpId.unshift(" ")
    numPass.unshift(" ")
    setNumOfPass(numPass)
    setTransportationId(transpId)
  }

  useEffect(() => {
    fetchHotelRates(tourId)
    fetchNumOfPass()
  }, [])

  return (
    <div>
      <Card className='text-center'>
        <Card.Img src={product.image} variant='top' height='200px' />
        <Card.Body>
          <Card.Title as='h4'>
            <strong>{product.name}</strong>
          </Card.Title>
          <Card.Text as='h5'>{product.description}</Card.Text>
          <Card.Text as='h3'>${tripPrice}</Card.Text>
          <Radio.Group buttonStyle='solid'>
            <Card.Text as='h6'>
              <strong>Select Trip</strong>
            </Card.Text>

            {product.arrivaltrip && (
              <Radio.Button
                value='Arrival'
                onClick={(e) => {
                  setKindOfTrip("Arrival")
                  setChargeByPerson(product.chargebyperson)
                  isSelectedHotel === false
                    ? handleShow()
                    : getPricesAPI(
                        transportationIdSelected,
                        numOfPassengers,
                        "Arrival",
                        zoneId
                      )
                }}
              >
                Arrival
              </Radio.Button>
            )}

            {product.departuretrip && (
              <Radio.Button
                value='Departure'
                onClick={(e) => {
                  setKindOfTrip("Departure")
                  setChargeByPerson(product.chargebyperson)
                  isSelectedHotel === false
                    ? handleShow()
                    : getPricesAPI(
                        transportationIdSelected,
                        numOfPassengers,
                        "Departure",
                        zoneId
                      )
                }}
              >
                Departure
              </Radio.Button>
            )}

            {product.roundtrip && (
              <Radio.Button
                value='Round'
                onClick={(e) => {
                  setKindOfTrip("Round")
                  setChargeByPerson(product.chargebyperson)
                  isSelectedHotel === false
                    ? handleShow()
                    : getPricesAPI(
                        transportationIdSelected,
                        numOfPassengers,
                        "Round",
                        zoneId
                      )
                }}
              >
                Round
              </Radio.Button>
            )}
          </Radio.Group>

          {isSelectedHotel && (
            <GeneralRatesTour
              hotelRates={hotelRates}
              value={hotelName}
              onChange={(event) => {
                sethotelId(
                  event.target[event.target.selectedIndex].getAttribute(
                    "data-hotelid"
                  )
                )
                setzoneId(
                  event.target[event.target.selectedIndex].getAttribute(
                    "data-zoneid"
                  )
                )
                sethotelName(event.target.value)
                getPricesAPI(
                  transportationIdSelected,
                  numOfPassengers,
                  kindOfTrip,
                  event.target[event.target.selectedIndex].getAttribute(
                    "data-zoneid"
                  )
                )
                setRender({ ...render, value: true })
              }}
            />
          )}

          {isSelectedHotel && (
            <GeneralTransportationsTour
              product={product}
              transportationNameSelected={transportationNameSelected}
              transportationId={transportationId}
              numOfPass={numOfPass}
              onChange={(event) => {
                setTransportationNameSelected(event.target.value)
                setTransportationIdSelected(
                  event.target[event.target.selectedIndex].getAttribute(
                    "data-transpid"
                  )
                )
                setNumOfPassengers(
                  event.target[event.target.selectedIndex].getAttribute(
                    "data-numofpass"
                  )
                )
                getPricesAPI(
                  event.target[event.target.selectedIndex].getAttribute(
                    "data-transpid"
                  ),
                  event.target[event.target.selectedIndex].getAttribute(
                    "data-numofpass"
                  ),
                  kindOfTrip,
                  zoneId
                )
              }}
            />
          )}
          <br />
          {tripPriceBool && (
            <Link
              to={{
                pathname: `/services-tours/${product._id}/${tourId}`,
                state: {
                  tripPrice: tripPrice,
                  transportationNameSelected: transportationNameSelected,
                  kindOfTrip: kindOfTrip,
                  serviceId: product._id,
                  transportationIdSelected: transportationIdSelected,
                  tourId: tourId,
                  tourProject: tourProject,
                },
              }}
            >
              <Button variant='outline-dark' size='md'>
                Buy
              </Button>
            </Link>
          )}
        </Card.Body>
      </Card>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title></Modal.Title>
        </Modal.Header>

        <Modal.Footer class='modal-title w-100 text-center'>
          <Card className='text-center'>
            <Card.Body>
              <GeneralRatesTour
                hotelRates={hotelRates}
                value={hotelName}
                onChange={(event) => {
                  sethotelId(
                    event.target[event.target.selectedIndex].getAttribute(
                      "data-hotelid"
                    )
                  )
                  setzoneId(
                    event.target[event.target.selectedIndex].getAttribute(
                      "data-zoneid"
                    )
                  )
                  sethotelName(event.target.value)
                  setshowTransportations(true)
                }}
              />

              {showTransportations && (
                <GeneralTransportationsTour
                  product={product}
                  transportationNameSelected={transportationNameSelected}
                  transportationId={transportationId}
                  numOfPass={numOfPass}
                  onChange={(event) => {
                    setTransportationNameSelected(event.target.value)
                    setTransportationIdSelected(
                      event.target[event.target.selectedIndex].getAttribute(
                        "data-transpid"
                      )
                    )
                    setNumOfPassengers(
                      event.target[event.target.selectedIndex].getAttribute(
                        "data-numofpass"
                      )
                    )
                    setIsSelectedHotel(true)
                    getPricesAPI(
                      event.target[event.target.selectedIndex].getAttribute(
                        "data-transpid"
                      ),
                      event.target[event.target.selectedIndex].getAttribute(
                        "data-numofpass"
                      ),
                      kindOfTrip,
                      zoneId
                    )
                    handleClose()
                  }}
                />
              )}
            </Card.Body>
          </Card>
        </Modal.Footer>
      </Modal>
    </div>
  )
}

export default GeneralServicesTours
